import React, { useState } from 'react';
import TableManager from '../../components/TableManager';
import useIcons from '../../assets/icons/useIcons';
import Button from '../../components/Button';
import AsideModal from '../../components/AsideModal';
import AddConsumer from './AddConsumer';
import { getConsumer } from '../../api';
import Dropdown from '../../components/Dropdown';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../helpers/functions';
import useDashBoardLogin from '../../hooks/useDashBoardLogin';

const filterInitialValues = {
  filter: [
    {
      key: 'firstName',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Name',
      inputType: 'text',
      inputLabel: 'Name',
    },

    {
      key: 'email',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Email',
      inputType: 'email',
      inputLabel: 'Email',
    },
    {
      key: 'phone',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Phone#',
      inputType: 'phone-number',
      inputLabel: 'Phone',
    },
  ],
};

const initialEditInstance = { isEdit: false, editData: {} };
export default function Consumer() {
  const { SuccessOutlineIcon, CrossIcon } = useIcons();

  const [addMember, setAddMember] = useState(false);

  const { mutate: mutateDashBoardLogin } = useDashBoardLogin();

  const [editUserInstance, setEditUserInstance] = useState(initialEditInstance);
  const { MoreVIcon } = useIcons();
  const navigate = useNavigate();

  const handleDropListClick = async ({ value }, data) => {
    const { _id } = data || {};

    switch (value) {
      case 'view':
        navigate(`/user-info/${_id}/consumer-profile`, { state: data });

        break;
      case 'go_to_dashboard':
        mutateDashBoardLogin(_id);

        break;

      default:
        break;
    }
  };

  const columns = [
    {
      accessorKey: 'full_name',
      accessorFn: (row) => `${row.firstName} ${row.lastName}`,
      header: () => 'Full Name',
      cell: (props) => {
        const element = props.row.original;
        return (
          <span
            className="c--pointer text--danger font--600 d--flex gap--sm d--flex align-items--center justify-content--start"
            // onClick={() => handleUserDetailsModal(props?.row?.original)}
          >
            {element?.status === 'ACTIVATE' ? (
              <div
                data-tooltip={'Active'}
                tooltip-position="top"
                className="bg--success radius--full p-l--sm  p-r--sm w-min--20 h-min--20 w-max--20 h-max--20  text--white d--flex justify-content--center align-items--center"
              >
                A
              </div>
            ) : (
              <div
                data-tooltip={'Deactive'}
                tooltip-position="top"
                className="bg--secondary radius--full p-l--sm p-r--sm w-min--20 h-min--20 w-max--20 h-max--20 text--white d--flex justify-content--center align-items--center"
              >
                D
              </div>
            )}
            {props.getValue()}
          </span>
        );
      },
      meta: {
        textAlign: 'left',
      },
    },

    {
      accessorKey: 'email',
      header: () => 'Email',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'phone',
      header: () => 'Phone',
      meta: {
        textAlign: 'left',
      },
    },

    {
      accessorKey: 'isSkipVerification',
      header: () => 'OTP',
      meta: {
        textAlign: 'center',
      },
      cell: (props) => {
        return (
          <span className="c--pointer text--danger font--600 d--flex justify-content--center">
            {props.getValue() ? (
              <div
                // data-tooltip={'Verified'}
                tooltip-position="top"
                className="bg--success radius--full w-min--14 w-max--14 h-min--14 h-max--14   text--white d--flex justify-content--center align-items--center"
              >
                <SuccessOutlineIcon width={22} height={22} />
              </div>
            ) : (
              <div
                // data-tooltip={'Not Verified'}
                tooltip-position="top"
                className="bg--danger radius--full  w-min--14 w-max--14 h-min--14 h-max--14  text--white d--flex justify-content--center align-items--center"
              >
                <CrossIcon height={22} width={22} />
              </div>
            )}
          </span>
        );
      },
    },
    {
      accessorKey: 'isVerify',
      header: () => 'Face',
      meta: {
        textAlign: 'center',
      },
      cell: (props) => {
        return (
          <span className="c--pointer text--danger font--600 d--flex justify-content--center">
            {/* {!props.getValue() ? (
              <div
                data-tooltip={'Verified'}
                tooltip-position="top"
                className="bg--success radius--full w-min--24 w-max--24 h-min--24 h-max--24   text--white d--flex justify-content--center align-items--center"
              >
                <SuccessOutlineIcon width={25} height={25} />
              </div>
            ) : ( */}
            <div
              // data-tooltip={'Not Verified'}
              tooltip-position="top"
              className="bg--danger radius--full  text--white d--flex justify-content--center align-items--center"
            >
              <CrossIcon height={25} width={25} />
            </div>
            {/* )} */}
          </span>
        );
      },
    },

    {
      accessorKey: 'createdAt',
      header: () => 'Registration On',
      cell: (props) => formatDate(props.getValue()),
      meta: {
        textAlign: 'center',
      },
    },
    {
      accessorKey: 'action',
      header: () => 'Action',
      cell: (props) => {
        const element = props?.row?.original;
        return (
          <div className="gap--xs w--full d--flex align-items--center justify-content--center">
            <Dropdown
              closeOnClickOutside={true}
              dropList={{
                component: ({ item }) => (
                  <span
                    className="w--full d--flex  justify-content--start p--sm"
                    onClick={() => handleDropListClick(item, element)}
                  >
                    {item?.title}
                  </span>
                ),
                data: [
                  { title: 'View', value: 'view' },

                  { title: 'Go to dashboard', value: 'go_to_dashboard' },
                ],
              }}
              showcaret={false}
            >
              <div className="w-min--32 h-min--32 d--flex align-items--center justify-content--center radius--sm bg--black-100 text--black  c--pointer">
                <MoreVIcon width={15} height={15} />
              </div>
            </Dropdown>
          </div>
        );
      },
      meta: {
        colType: 'action',
        textAlign: 'center',
        width: '5%',
      },
    },
  ];

  const tableActions = [
    {
      id: 1,
      access: true,
      component: (
        <Button
          type="button"
          btnClasses="btn w-min--150"
          variant="primary"
          color="white"
          onClick={() => setAddMember(true)}
        >
          Add User
        </Button>
      ),
    },
  ];
  const handleClose = () => {
    setEditUserInstance({ isEdit: false, editData: {} });
    setAddMember(false);
  };

  return (
    <div className="w--full">
      <TableManager
        {...{
          fetcherKey: 'getConsumer',
          fetcherFn: getConsumer,
          columns,
          name: 'Consumer',
          shouldFilter: true,
          initialFilterState: filterInitialValues,
          selectCBForTableData: (tblData) => tblData?.data?.data?.users,
        }}
      />
      {addMember && (
        <AsideModal
          handleClose={handleClose}
          title="User"
          footerComponent={null}
        >
          <AddConsumer
            editUserInstance={editUserInstance}
            handleClose={handleClose}
          />
        </AsideModal>
      )}
    </div>
  );
}
